import { Outlet } from "react-router";
import { BaseLayout } from "@cmde/shadcn";
import { AppFooter } from "@/components/layouts/app-footer";
import { AppHeader } from "@/components/layouts/app-header";
import { AppSidebar } from "@/components/sidebar/app-sidebar";

function AppLayout() {
  return (
    <BaseLayout
      className="min-h-svh [&>div:first-of-type]:h-auto [&>div:first-of-type]:min-h-auto [&>div:first-of-type]:flex-1"
      header={<AppHeader />}
      sidebar={<AppSidebar />}
      footer={<AppFooter />}
    >
      <Outlet />
    </BaseLayout>
  );
}

export default AppLayout;
